import React from 'react';
import { Row, Col } from 'reactstrap';
import { useNavigate, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import LinkButton from './LinkButton';

interface Props {
  title: string | React.ReactNode;
  noBack?: boolean;
  side?: React.ReactNode;
  link?: React.ReactNode;
  // button?: { text: string; handleClick: () => void };
  backTimes?: number;
  backUrl?: string;
  children?: React.ReactNode;
}

const PageHeader: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { title, side, link, children, backTimes, backUrl, noBack = false } = props;

  const times = backTimes || 1;
  const getXLastIndex = (url: string, x: number): number =>
    url.lastIndexOf('/', x > 1 ? getXLastIndex(url, x - 1) - 1 : undefined);

  const back = () => {
    const lastLocation =
      backUrl || location.pathname.substr(0, getXLastIndex(location.pathname, times));
    navigate(lastLocation, { replace: true });
    // maybe changes here
  };

  return (
    <div className="title-row">
      {!noBack && (
        <Row>
          <Col>
            <div className="page-header-link">
              <LinkButton text={t('back')} onClick={back} icon="arrow-left" />
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <div className="title-content">
            <div className="page-title">
              <div className="d-flex flex-row">
                <h1>
                  <span>{title}</span>
                </h1>
                <div className="ml-1">{link}</div>
              </div>
              <div className="title-content__side">{side}</div>
            </div>
            {children}
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PageHeader;
